import React from "react";

import { DrawerContainerComponent } from "./drawer-container.component";
import { DrawerBody } from "./components/drawer-body.component";
import { forceRange } from "../cp-modal/modal.utils";
import { drawerWidthMax, drawerWidthMin } from "./drawer.utils";
import { CpModal } from "@components";

type DrawerProps = {
  bottom?: number;
  children?: React.ReactNode;
  className?: string;
  onClose: () => void;
  onAfterClose?: () => void;
  onAfterOpen?: () => void;
  show: boolean;
  styles?: React.CSSProperties;
  top?: number;
  width?: number;
  position?: "left" | "right";
};

export function CpDrawer({
  children,
  styles,
  top = 0,
  bottom,
  width = 320,
  position = "right",
  ...props
}: DrawerProps) {
  if (top !== 0 && bottom !== undefined) {
    console.warn(
      "Both 'top' and 'bottom' props were provided to the CpDrawer. Only one can be used; the 'top' value will be preferred.",
    );
  }
  // If both top and bottom are defined, prioritize top; otherwise, use bottom if defined, or default to top if only top is provided.
  const verticalPosition =
    !top && bottom !== undefined
      ? { bottom: `${bottom}px` }
      : { top: `${top}px` };

  return (
    <DrawerContainerComponent
      {...props}
      styles={{
        width: `${forceRange(width, drawerWidthMin, drawerWidthMax) / 10}rem`,
        maxHeight: `calc(100vh - ${top + 48}px)`,
        position: "absolute",
        margin: "2.4rem",
        ...(position === "right" ? { right: "0" } : { left: "80px" }),
        ...verticalPosition,
        ...styles,
      }}
      position={position}
      animScale={0.92}
      visibleBackdrop={false}
    >
      {children}
    </DrawerContainerComponent>
  );
}

CpDrawer.Header = CpModal.Header;
CpDrawer.Body = DrawerBody;
CpDrawer.Footer = CpModal.Footer;
